import { Pipe, PipeTransform, inject } from '@angular/core';
import { TextReplace, TranslateService } from '../../services/translate.service';

@Pipe({
  name: 'translateLabel',
  pure: false,
  standalone: true,
})
export class TranslateLabelPipe implements PipeTransform {
  private translate = inject(TranslateService);

  transform(label: string, replaces?: TextReplace[]): string {
    const translatableLabels = ['Red', 'Green', 'Blue', 'Orange', 'Purple'];
    if (!translatableLabels.includes(label)) return label;
    return this.translate.getSync(`label-${label.toLowerCase()}`, replaces);
  }
}
